import React, { memo } from 'react';
import type { FunctionComponent } from 'react';
import './ListOfAccounts.scss';
import { useListOfAccounts } from './useListOfAccounts';
import { Grid, GridColumn, GridActionsCellRenderer } from '@web-components-proxy';
import { Loader } from '@shared-components';
import { useGeneralErrorHandler } from '@http';
import type { ResponseData } from './utils';

interface ListOfAccountsProps {
	accountsData: ResponseData[];
	isLoading: boolean;
}

export const ListOfAccounts: FunctionComponent<ListOfAccountsProps> = memo(({ accountsData, isLoading }) => {
	const setError = useGeneralErrorHandler();
	const { gridRef, columnsDefinition } = useListOfAccounts(setError, accountsData, isLoading);

	return (
		<div className="list-of-accounts">
			{isLoading && <Loader fullscreen={false} />}
			<Grid theme="list" size="medium" class="list-of-accounts__grid" ref={gridRef}>
				<GridColumn default resizable />
				{columnsDefinition.map((item, index) => {
					if (item.actions) {
						return (
							<GridColumn {...item.options} ref={item.ref} key={index}>
								<GridActionsCellRenderer
									key={`action${index}`}
									ref={item.actions.ref}
									maxVisibleActions={1}
								/>
							</GridColumn>
						);
					}
					return <GridColumn {...item.options} ref={item.ref} key={index} />;
				})}
			</Grid>
		</div>
	);
});
